
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.667 1H2.333C1.597 1 1 1.597 1 2.333v9.334C1 12.403 1.597 13 2.333 13h9.334c.736 0 1.333-.597 1.333-1.333V2.333C13 1.597 12.403 1 11.667 1z","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.667 5.667a1 1 0 100-2 1 1 0 000 2zM13 9L9.667 5.667 2.333 13","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    